import styled from 'styled-components';
import { media } from '@sizeid/commons/utils/styles';

export default styled.div`
  padding-bottom: 50px;

  > img {
    width: 100%;
    max-width: 1000px;
    display: block;
    margin: 30px auto;
  }

  > p {
    margin: 30px 0 50px;
  }

  ${media.moreThan('smPlus')`
    > p {
      max-width: 825px;
      margin-left: auto;
      margin-right: auto;
    }
  `};
`;
